import { render, staticRenderFns } from "./HamburgerIcon.vue?vue&type=template&id=22f3aa4e&scoped=true&"
var script = {}
import style0 from "./HamburgerIcon.vue?vue&type=style&index=0&id=22f3aa4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f3aa4e",
  null
  
)

export default component.exports